import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from 'src/app/shared/services/config.service';
import { MawbService } from 'src/app/shared/services/mawb.service';
import { AddReferenceComponent } from '../invoice-reference/add-reference/add-reference.component';

@Component({
  selector: 'invoice-reference',
  templateUrl: './invoice-reference.component.html',
  styleUrls: ['./invoice-reference.component.css'],
})
export class InvoiceReferenceComponent implements OnInit {
  selectedInvoiceRef: any = [];
  constructor(
    readonly dialog: MatDialog,
    readonly configService: ConfigService,
    readonly mawbService: MawbService
  ) {}

  @Input()
  set setData(data: any) {
    this.selectedInvoiceRef = data.map(d => {
      return {
        type_code: d.typeCode,
        type_value: d.value,
      };
    });
  }
  get setData() {
    return this.selectedInvoiceRef;
  }

  _mawb: string;
  @Input()
  set mawb(id: string) {
    this._mawb = id;
  }
  get mawb() {
    return this._mawb;
  }

  _isClosed: boolean = true;
  @Input()
  set isClosed(b: boolean) {
    this._isClosed = b;
  }
  get isClosed() {
    return this._isClosed;
  }

  ngOnInit(): void {}

  add() {
    const dialogRef = this.dialog.open(AddReferenceComponent, {
      autoFocus: false,
      maxHeight: '80vh',
      maxWidth: '80vw',
      data: {
        referenceData: this.selectedInvoiceRef,
      },
    });
    dialogRef.afterClosed().subscribe(response => {
      this.selectedInvoiceRef = response.data;
      const payload = this.selectedInvoiceRef.map(this.mapPayLoad);
      this.callService(this.mawb, payload);
    });
  }

  remove(invRef: any): void {
    const index = this.selectedInvoiceRef.indexOf(invRef);
    if (index >= 0) {
      this.selectedInvoiceRef.splice(index, 1);
      const payload = this.selectedInvoiceRef.map(this.mapPayLoad);
      this.callService(this.mawb, payload);
    }
  }

  mapPayLoad(d) {
    return {
      value: d.type_value,
      typeCode: d.type_code,
    };
  }

  callService(mawb, payload) {
    this.mawbService.updatemawbInvoiceRerence(mawb, payload).subscribe(() => {});
  }
}
